<template>
  <div class="waitLease-group-dashboard-unsentableCars" v-loading="loading">
    <AlertBox
      class="mb16"
      title="不可发车辆概览、不可发原因概览为准实时数据，数据更新可能会存在一小时左右的延迟"
      btnText="刷新数据"
      @btnClick="update"
    />

    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <div class="module-title">不可发概况</div>

    <!-- 不可发车辆概览 -->
    <HorizontalCardStyle3
      class="mb16"
      :title="toDealOverviewData.title"
      :dataDesc="toDealOverviewData.dataDesc"
      :dataUpdateTime="dataUpdateTime"
      :primaryDataList="toDealOverviewData.primaryDataList"
      :secondaryDataList="toDealOverviewData.secondaryDataList"
    />

    <FiltersBox
      class="mb16"
      :filterList="toDealNumRateChartFilter.filterList"
      :model.sync="toDealNumRateChartFilter.model"
      @change="handleToDealNumRateChartFiltersChange"
    />

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 不可发车数量（折线图） -->
        <LineChartCard
          class="chart"
          :title="toDealNumChartData.title"
          :tooltip="toDealNumChartData.tooltip"
          :dataDesc="toDealNumChartData.dataDesc"
          :dataUpdateTime="toDealNumChartData.dataUpdateTime"
          :xAxis="toDealNumChartData.xAxis"
          :yAxis="toDealNumChartData.yAxis"
          :legendData="toDealNumChartData.legendData"
          :seriesData="toDealNumChartData.seriesData"
          :unit="toDealNumChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 不可发车率（折线图） -->
        <LineChartCard
          class="chart"
          :title="toDealRateChartData.title"
          :tooltip="toDealRateChartData.tooltip"
          :dataDesc="toDealRateChartData.dataDesc"
          :dataUpdateTime="toDealRateChartData.dataUpdateTime"
          :xAxis="toDealRateChartData.xAxis"
          :yAxis="toDealRateChartData.yAxis"
          :legendData="toDealRateChartData.legendData"
          :seriesData="toDealRateChartData.seriesData"
          :unit="toDealRateChartData.unit"
        />
      </el-col>
    </el-row>

    <div class="module-title">不可发原因</div>

    <!-- 证照 -->
    <HorizontalCardStyle3
      class="mb16"
      :title="toDealNumLicenseData.title"
      :tooltip="toDealNumLicenseData.tooltip"
      :dataDesc="toDealNumLicenseData.dataDesc"
      :dataUpdateTime="toDealNumLicenseData.dataUpdateTime"
      :primaryDataList="toDealNumLicenseData.primaryDataList"
      :secondaryDataList="toDealNumLicenseData.secondaryDataList"
    />

    <!-- 不可租标签 -->
    <HorizontalCardStyle3
      class="mb16"
      :title="toDealNumTagData.title"
      :tooltip="toDealNumTagData.tooltip"
      :dataDesc="toDealNumTagData.dataDesc"
      :dataUpdateTime="toDealNumTagData.dataUpdateTime"
      :primaryDataList="toDealNumTagData.primaryDataList"
      :secondaryDataList="toDealNumTagData.secondaryDataList"
    />

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
         <!-- 违章 -->
        <HorizontalCardStyle1
          :title="toDealNumViolationData.title"
          :tooltip="toDealNumViolationData.tooltip"
          :dataDesc="toDealNumViolationData.dataDesc"
          :dataUpdateTime="toDealNumViolationData.dataUpdateTime"
          :primaryDataList="toDealNumViolationData.primaryDataList"
          :secondaryDataList="toDealNumViolationData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
         <!-- 事故 -->
        <HorizontalCardStyle1
          :title="toDealNumAccidentData.title"
          :tooltip="toDealNumAccidentData.tooltip"
          :dataDesc="toDealNumAccidentData.dataDesc"
          :dataUpdateTime="toDealNumAccidentData.dataUpdateTime"
          :primaryDataList="toDealNumAccidentData.primaryDataList"
          :secondaryDataList="toDealNumAccidentData.secondaryDataList"
        />
      </el-col>
    </el-row>

     <el-row class="mb16" :gutter="16">
      <el-col :span="12">
         <!-- 保险 -->
        <HorizontalCardStyle1
          :title="toDealNumInsuranceData.title"
          :tooltip="toDealNumInsuranceData.tooltip"
          :dataDesc="toDealNumInsuranceData.dataDesc"
          :dataUpdateTime="toDealNumInsuranceData.dataUpdateTime"
          :primaryDataList="toDealNumInsuranceData.primaryDataList"
          :secondaryDataList="toDealNumInsuranceData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
         <!-- 维保 -->
        <HorizontalCardStyle1
          :title="toDealNumMaintenanceData.title"
          :tooltip="toDealNumMaintenanceData.tooltip"
          :dataDesc="toDealNumMaintenanceData.dataDesc"
          :dataUpdateTime="toDealNumMaintenanceData.dataUpdateTime"
          :primaryDataList="toDealNumMaintenanceData.primaryDataList"
          :secondaryDataList="toDealNumMaintenanceData.secondaryDataList"
        />
      </el-col>
    </el-row>
    <template v-if="false">
      <FiltersBox
        class="mb16"
        :filterList="toDealReasonChartFilter.filterList"
        :model.sync="toDealReasonChartFilter.model"
        @change="handleToDealReasonChartFiltersChange"
      />

      <el-row class="mb16" :gutter="16">
        <el-col :span="12">
          <!-- 证照原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumLicenseChartData.title"
            :tooltip="toDealNumLicenseChartData.tooltip"
            :dataDesc="toDealNumLicenseChartData.dataDesc"
            :dataUpdateTime="toDealNumLicenseChartData.dataUpdateTime"
            :xAxis="toDealNumLicenseChartData.xAxis"
            :yAxis="toDealNumLicenseChartData.yAxis"
            :legendData="toDealNumLicenseChartData.legendData"
            :seriesData="toDealNumLicenseChartData.seriesData"
            :unit="toDealNumLicenseChartData.unit"
          />
        </el-col>
        <el-col :span="12">
          <!-- 不可租标签原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumTagChartData.title"
            :tooltip="toDealNumTagChartData.tooltip"
            :dataDesc="toDealNumTagChartData.dataDesc"
            :dataUpdateTime="toDealNumTagChartData.dataUpdateTime"
            :xAxis="toDealNumTagChartData.xAxis"
            :yAxis="toDealNumTagChartData.yAxis"
            :legendData="toDealNumTagChartData.legendData"
            :seriesData="toDealNumTagChartData.seriesData"
            :unit="toDealNumTagChartData.unit"
          />
        </el-col>
      </el-row>

      <el-row class="mb16" :gutter="16">
        <el-col :span="12">
          <!-- 违章原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumViolationChartData.title"
            :tooltip="toDealNumViolationChartData.tooltip"
            :dataDesc="toDealNumViolationChartData.dataDesc"
            :dataUpdateTime="toDealNumViolationChartData.dataUpdateTime"
            :xAxis="toDealNumViolationChartData.xAxis"
            :yAxis="toDealNumViolationChartData.yAxis"
            :legendData="toDealNumViolationChartData.legendData"
            :seriesData="toDealNumViolationChartData.seriesData"
            :unit="toDealNumViolationChartData.unit"
          />
        </el-col>
        <el-col :span="12">
          <!-- 事故原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumAccidentChartData.title"
            :tooltip="toDealNumAccidentChartData.tooltip"
            :dataDesc="toDealNumAccidentChartData.dataDesc"
            :dataUpdateTime="toDealNumAccidentChartData.dataUpdateTime"
            :xAxis="toDealNumAccidentChartData.xAxis"
            :yAxis="toDealNumAccidentChartData.yAxis"
            :legendData="toDealNumAccidentChartData.legendData"
            :seriesData="toDealNumAccidentChartData.seriesData"
            :unit="toDealNumAccidentChartData.unit"
          />
        </el-col>
      </el-row>

      <el-row class="mb16" :gutter="16">
        <el-col :span="12">
          <!-- 保险原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumInsuranceChartData.title"
            :tooltip="toDealNumInsuranceChartData.tooltip"
            :dataDesc="toDealNumInsuranceChartData.dataDesc"
            :dataUpdateTime="toDealNumInsuranceChartData.dataUpdateTime"
            :xAxis="toDealNumInsuranceChartData.xAxis"
            :yAxis="toDealNumInsuranceChartData.yAxis"
            :legendData="toDealNumInsuranceChartData.legendData"
            :seriesData="toDealNumInsuranceChartData.seriesData"
            :unit="toDealNumInsuranceChartData.unit"
          />
        </el-col>
        <el-col :span="12">
          <!-- 维保原因不可发-图表 -->
          <LineChartCard
            :title="toDealNumMaintenanceChartData.title"
            :tooltip="toDealNumMaintenanceChartData.tooltip"
            :dataDesc="toDealNumMaintenanceChartData.dataDesc"
            :dataUpdateTime="toDealNumMaintenanceChartData.dataUpdateTime"
            :xAxis="toDealNumMaintenanceChartData.xAxis"
            :yAxis="toDealNumMaintenanceChartData.yAxis"
            :legendData="toDealNumMaintenanceChartData.legendData"
            :seriesData="toDealNumMaintenanceChartData.seriesData"
            :unit="toDealNumMaintenanceChartData.unit"
          />
        </el-col>
      </el-row>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import AlertBox from '@/bizComponents/Dashboard/alertBox'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1'
import HorizontalCardStyle3 from '@/bizComponents/Dashboard/cards/horizontalCard/style3'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard'
import { getYAxisNumMax, getYAxisNumMin, getYAxisPercentMin } from '@/bizComponents/Dashboard/utils/function'
import {
  getVehicleHoldInfo,
  getToDealNum,
  getToDealRate,
  getToDealReason,
  getToDealNumWithLicense,
  getToDealNumWithTag,
  getToDealNumWithViolation,
  getToDealNumWithAccident,
  getToDealNumWithInsurance,
  getToDealNumWithMaintenance,
} from '@/api/domain/waitLease'
import { useQueryStringify } from '@/utils/useAutoQuery'
import { TABS } from '@/pages/cars/list/config'

export default {
  components: {
    AlertBox,
    FiltersBox,
    HorizontalCardStyle1,
    HorizontalCardStyle3,
    LineChartCard,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 不可发车数量&不可发车率筛选
      toDealNumRateChartFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            // 结束日期不可>当前日期，时间范围不可大于1年
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 365,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
          {
            type: 'select',
            label: '视角',
            name: 'type',
            options: [
              {
                label: '部门',
                value: 1,
              },
              {
                label: '车型',
                value: 2,
              },
            ],
          },
        ],
        model: {
          // 默认最近30天
          date: [
            moment(moment(Date.now() - 24 * 60 * 60 * 1000 - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(moment(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
          type: 1,
        },
      },
      // 不可发原因图表筛选
      toDealReasonChartFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            // 结束日期不可>当前日期，时间范围不可大于1年
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 365,
              },
              disabledDate: (time) => {
                return time.getTime() >= moment(moment().format('YYYY-MM-DD 00:00:00')).valueOf()
              },
            },
          },
          {
            type: 'select',
            label: '视角',
            name: 'type',
            options: [
              {
                label: '部门',
                value: 1,
              },
              {
                label: '车型',
                value: 2,
              },
            ],
          },
        ],
        model: {
          // 默认最近30天
          date: [
            moment(moment(Date.now() - 24 * 60 * 60 * 1000 - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(moment(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
          type: 1,
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 不可发车辆概览
      toDealOverviewData: {
        title: '不可发车辆概览',
        dataDesc: '实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发车数量
      toDealNumChartData: {
        title: '不可发车数量',
        tooltip: '每日不可发车辆数量',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
          min: (value) => getYAxisNumMin(value, 50),
        },
        legendData: [],
        seriesData: [],
      },
      // 不可发车率
      toDealRateChartData: {
        title: '不可发车率',
        tooltip: '不可发车率=不可发车数量/已新车入库数量*100%',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          max: 100,
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 不可发原因-证照
      toDealNumLicenseData: {
        title: '证照',
        tooltip: '当日“证照”原因不可发数量',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发原因-不可租标签
      toDealNumTagData: {
        title: '不可租标签',
        tooltip: '当日“XXX”原因不可发数量（XXX为不可租标签类型下的具体标签内容，提示说明时回显对应值）',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发原因-违章
      toDealNumViolationData: {
        title: '违章',
        tooltip: '当日“有待处理违章”原因不可发数量',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发原因-事故
      toDealNumAccidentData: {
        title: '事故',
        tooltip: '当日“有未完成事故任务”原因不可发数量',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发原因-保险
      toDealNumInsuranceData: {
        title: '保险',
        tooltip: '当日“保险”原因不可发数量',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 不可发原因-维保
      toDealNumMaintenanceData: {
        title: '维保',
        tooltip: '当日“维保”原因不可发数量',
        dataDesc: '实时数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 证照原因不可发-图表
      toDealNumLicenseChartData: {
        title: '证照原因不可发',
        tooltip: '每日“证照”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 不可租标签原因不可发-图表
      toDealNumTagChartData: {
        title: '不可租标签原因不可发',
        tooltip: '每日“不可租标签”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 违章原因不可发-图表
      toDealNumViolationChartData: {
        title: '违章原因不可发',
        tooltip: '每日“违章”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 事故原因不可发-图表
      toDealNumAccidentChartData: {
        title: '事故原因不可发',
        tooltip: '每日“事故”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 保险原因不可发-图表
      toDealNumInsuranceChartData: {
        title: '保险原因不可发',
        tooltip: '每日“保险”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      // 维保原因不可发-图表
      toDealNumMaintenanceChartData: {
        title: '维保原因不可发',
        tooltip: '每日“维保”原因不可发数量',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 5),
          min: (value) => getYAxisNumMin(value, 5),
        },
        legendData: [],
        seriesData: [],
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    commonParams() {
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
      }
    },
    toDealNumParams() {
      const { date } = this.toDealNumRateChartFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        type: this.toDealNumRateChartFilter.model.type,
        startDate,
        endDate,
      }
    },
    toDealReasonParams() {
      const { date } = this.toDealReasonChartFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        type: this.toDealReasonChartFilter.model.type,
        startDate,
        endDate,
      }
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.getToDealNumOverview(),
        this.getToDealReasonOverview(),
        this.getToDealNumChart(),
        this.getToDealRateChart(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleToDealNumRateChartFiltersChange() {
      this.loading = true
      Promise.all([
        this.getToDealNumChart(),
        this.getToDealRateChart(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleToDealReasonChartFiltersChange() {
      this.loading = true
      Promise.all([
        this.getToDealNumWithLicenseChart(),
        this.getToDealNumWithTagChart(),
        this.getToDealNumWithViolationChart(),
        this.getToDealNumWithAccidentChart(),
        this.getToDealNumWithInsuranceChart(),
        this.getToDealNumWithMaintenanceChart(),
      ]).finally(() => {
        this.loading = false
      })
    },
    // 跳转车辆-车辆列表
    toVehicleManageList({ tab, groupType, itemType }) {
      const selectedDeptId = this.globalFilter.model.deptId
      const query = {
        b: '',
        g: {},
        f: {
          deptIdList: selectedDeptId !== this.rootDeptId ? [this.globalFilter.model.deptId] : [],
        },
      }
      // tab '0':全部车辆 '5':待入库 '10':待处理 '20':待租 '40':已租 'outCar':退出运营
      if (typeof tab !== 'undefined') {
        query.b = String(tab)
      }
      // 不可租标签大类 1(证照状态) 2(不可租标签) 3(车务状态)
      if (typeof groupType !== 'undefined') {
        query.g.groupType = groupType
      }
      // 不可租标签细分类
      if (typeof itemType !== 'undefined') {
        query.g.itemType = itemType
      }
      this.$router.push(`/vehicle/vehicleManage/list?${useQueryStringify(query)}`)
    },
    // 获取不可发车辆概览
    async getToDealNumOverview() {
      const res = await getVehicleHoldInfo(this.commonParams)
      const { code, data } = res

      if (code === 1 && data) {
        this.dataUpdateTime = data.updateTime || ''
        this.toDealOverviewData.primaryDataList = [
          {
            label: '累计不可发数量',
            value: data?.toDeal?.totalNumber || 0,
            unit: '辆',
            tooltip: '当前累计不可发车辆数量',
            // 跳转车辆-车辆列表-待处理车辆
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          },
        ]
        this.toDealOverviewData.secondaryDataList = [
          {
            label: '今日新增不可发',
            value: data?.toDeal?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增经历过不可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toDeal?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toDeal?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '今日不可发转可发',
            value: data?.toLease?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日经历过不可发转可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toLease?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toLease?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '昨日新增不可发',
            value: data?.toDeal?.yesterdayNumber || 0,
            unit: '辆',
            tooltip: '昨日新增经历过不可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toDeal?.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toDeal?.yesterdayNumberWeekYoY,
              },
            ],
          },
          {
            label: '昨日不可发转可发',
            value: data?.toLease?.yesterdayNumber || 0,
            unit: '辆',
            tooltip: '昨日经历过不可发转可发的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data?.toLease?.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data?.toLease?.yesterdayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增不可发',
            value: data?.toDeal?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周时间范围内，新增经历过不可发的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data?.toDeal?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本周不可发转可发',
            value: data?.toLease?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周时间范围内，经历过不可发转可发的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data?.toLease?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增不可发',
            value: data?.toDeal?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月时间范围内，新增经历过不可发的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data?.toDeal?.monthNumberRadio,
              },
            ],
          },
          {
            label: '本月不可发转可发',
            value: data?.toLease?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月时间范围内，经历过不可发转可发的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data?.toLease?.monthNumberRadio,
              },
            ],
          },
        ]
      }
    },
    // 获取不可发车数量图表
    async getToDealNumChart() {
      const res = await getToDealNum({
        ...this.commonParams,
        ...this.toDealNumParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumChartData.legendData = data.nameList || []
        this.toDealNumChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealNumRateChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumChartData.seriesData = this.toDealNumChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取不可发车率图表
    async getToDealRateChart() {
      const res = await getToDealRate({
        ...this.commonParams,
        ...this.toDealNumParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealRateChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealRateChartData.legendData = data.nameList || []
        this.toDealRateChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealNumRateChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealRateChartData.seriesData = this.toDealRateChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.toDealRateChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取不可发原因概览
    async getToDealReasonOverview() {
      const res = await getToDealReason(this.commonParams)
      const { code, data } = res

      if (code === 1 && data) {
        // 证照
        this.toDealNumLicenseData.dataUpdateTime = data.updateTime || ''
        this.toDealNumLicenseData.primaryDataList = data.license && data.license[0]
          ? [{
            label: data.license ? data.license[0]?.name : '',
            value: data.license ? data.license[0]?.num : '',
            tooltip: data.license ? data.license[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.license ? data.license[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.license ? data.license[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumLicenseData.secondaryDataList = data?.license?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-证照原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []

        // 不可租标签
        this.toDealNumTagData.dataUpdateTime = data.updateTime || ''
        this.toDealNumTagData.primaryDataList = data.tag && data.tag[0]
          ? [{
            label: data.tag ? data.tag[0]?.name : '',
            value: data.tag ? data.tag[0]?.num : '',
            tooltip: data.tag ? data.tag[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.tag ? data.tag[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.tag ? data.tag[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumTagData.secondaryDataList = data?.tag?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-标签原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []

        // 违章
        this.toDealNumViolationData.dataUpdateTime = data.updateTime || ''
        this.toDealNumViolationData.primaryDataList = data.violation && data.violation[0]
          ? [{
            label: data.violation ? data.violation[0]?.name : '',
            value: data.violation ? data.violation[0]?.num : '',
            tooltip: data.violation ? data.violation[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.violation ? data.violation[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.violation ? data.violation[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumViolationData.secondaryDataList = data?.violation?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          width: '33.3333% !important',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-违章原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []

        // 事故
        this.toDealNumAccidentData.dataUpdateTime = data.updateTime || ''
        this.toDealNumAccidentData.primaryDataList = data.accident && data.accident[0]
          ? [{
            label: data.accident ? data.accident[0]?.name : '',
            value: data.accident ? data.accident[0]?.num : '',
            tooltip: data.accident ? data.accident[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.accident ? data.accident[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.accident ? data.accident[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumAccidentData.secondaryDataList = data?.accident?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          width: '33.3333% !important',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-事故原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []

        // 保险
        this.toDealNumInsuranceData.dataUpdateTime = data.updateTime || ''
        this.toDealNumInsuranceData.primaryDataList = data.insurance && data.insurance[0]
          ? [{
            label: data.insurance ? data.insurance[0]?.name : '',
            value: data.insurance ? data.insurance[0]?.num : '',
            tooltip: data.insurance ? data.insurance[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.insurance ? data.insurance[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.insurance ? data.insurance[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumInsuranceData.secondaryDataList = data?.insurance?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          width: '33.3333% !important',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-保险原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []

        // 维保
        this.toDealNumMaintenanceData.dataUpdateTime = data.updateTime || ''
        this.toDealNumMaintenanceData.primaryDataList = data.maintenance && data.maintenance[0]
          ? [{
            label: data.maintenance ? data.maintenance[0]?.name : '',
            value: data.maintenance ? data.maintenance[0]?.num : '',
            tooltip: data.maintenance ? data.maintenance[0]?.tooltip : '',
            ratioList: [
              {
                name: '日环比',
                value: data.maintenance ? data.maintenance[0]?.dayRadio : null,
              },
              {
                name: '周同比',
                value: data.maintenance ? data.maintenance[0]?.weekYoY : null,
              },
            ],
            // 跳转车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          }]
          : []
        this.toDealNumMaintenanceData.secondaryDataList = data?.maintenance?.slice(1).map((item) => ({
          label: item.name || '',
          value: item.num,
          tooltip: item.tooltip || '',
          width: '33.3333% !important',
          ratioList: [
            {
              name: '日环比',
              value: item.dayRadio,
            },
            {
              name: '周同比',
              value: item.weekYoY,
            },
          ],
          // 跳转车辆-车辆列表-待处理-维保原因
          clickCallback: () => this.toVehicleManageList({
            tab: TABS.WaitForHandle,
            groupType: item.groupType || '',
            itemType: item.itemType || '',
          }),
        })) || []
      }
    },
    // 获取证照原因不可发图表
    async getToDealNumWithLicenseChart() {
      const res = await getToDealNumWithLicense({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumLicenseChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumLicenseChartData.legendData = data.nameList || []
        this.toDealNumLicenseChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumLicenseChartData.seriesData = this.toDealNumLicenseChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumLicenseChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取不可租标签原因不可发图表
    async getToDealNumWithTagChart() {
      const res = await getToDealNumWithTag({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumTagChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumTagChartData.legendData = data.nameList || []
        this.toDealNumTagChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumTagChartData.seriesData = this.toDealNumTagChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumTagChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取违章原因不可发图表
    async getToDealNumWithViolationChart() {
      const res = await getToDealNumWithViolation({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumViolationChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumViolationChartData.legendData = data.nameList || []
        this.toDealNumViolationChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumViolationChartData.seriesData = this.toDealNumViolationChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumViolationChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取事故原因不可发图表
    async getToDealNumWithAccidentChart() {
      const res = await getToDealNumWithAccident({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumAccidentChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumAccidentChartData.legendData = data.nameList || []
        this.toDealNumAccidentChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumAccidentChartData.seriesData = this.toDealNumAccidentChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumAccidentChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取保险原因不可发图表
    async getToDealNumWithInsuranceChart() {
      const res = await getToDealNumWithInsurance({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumInsuranceChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumInsuranceChartData.legendData = data.nameList || []
        this.toDealNumInsuranceChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumInsuranceChartData.seriesData = this.toDealNumInsuranceChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumInsuranceChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取维保原因不可发图表
    async getToDealNumWithMaintenanceChart() {
      const res = await getToDealNumWithMaintenance({
        ...this.commonParams,
        ...this.toDealReasonParams,
      })
      const { code, data } = res

      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.toDealNumMaintenanceChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.toDealNumMaintenanceChartData.legendData = data.nameList || []
        this.toDealNumMaintenanceChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.toDealReasonChartFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.toDealNumMaintenanceChartData.seriesData = this.toDealNumMaintenanceChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (isCompanyView ? deptInfo?.num : seriesInfoItem?.num) || 0
              // 数据名称
              const dataTitle = this.toDealNumMaintenanceChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}

.mt24 {
  margin-top: 24px;
}

.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
